import React from 'react';
import { CourseBannerStyles } from './CourseBannerStyles';
import { InView } from 'react-intersection-observer';

function CourseBanner({
  image, imageMobile, imageAlt, level,
}: {image: string; imageMobile: string, imageAlt: string, level?: string}) {
  return (
    <CourseBannerStyles className="banner">
      <InView className="animationWrapper" onChange={(inView, entry) => (inView ? entry.target.classList.add('active') : '')}>
        <picture>
          <source media="(min-width: 501px)" srcSet={image} />
          <img src={imageMobile} alt={imageAlt} />
        </picture>
        {level && (
          <div className="container">
            <div className="level"><span>{level}</span></div>
          </div>
        )}
      </InView>
    </CourseBannerStyles>
  );
}

export default CourseBanner;
